import { ChecklistSectionType } from '../features/cleaningAdmin/checklists/types';

export const ApplicationRoutes = {
  customer: {
    checklist: '/customer/checklist'
  },
  account: {
    myProfile: '/my-profile',
    login: '/login',
    logout: '/logout',
    resetPassword: '/reset-password',
    confirmEmail: '/confirm-email',
    forgotPassword: '/forgot-password'
  },
  admin: {
    users: '/admin/users'
  },
  crm: {
    clients: '/crm/clients',
    properties: '/crm/properties'
  },
  cleaningAdmin: {
    inventory: '/cleaning-admin/inventory',
    checklists: '/cleaning-admin/checklists',
    cleaningPackages: '/cleaning-admin/cleaning-packages',
    training: '/cleaning-admin/video-admin',
    submittedChecklists: '/cleaning-admin/submitted-checklists',
    checklistReport: '/cleaning-admin/checklist-report'
  },
  scheduling: {
    calendar: '/scheduling/calendar',
    alerts: '/scheduling/alerts',
    availabilityDashboard: '/scheduling/availability'
  },
  training: {
    list: '/training',
    view: '/training/view'
  },
  cleaning: {
    inventoryReport: '/cleaning/inventory-report',
    mySchedule: '/cleaning/my-schedule',
    startCleaning: '/cleaning/start-cleaning',
    cleaningChecklist: (cleaningId: number) =>
      `/cleaning/cleaning-checklist/${ChecklistSectionType.Cleaner}/${cleaningId}`,
    previewChecklist: (cleaningId: number, checklistType: ChecklistSectionType) =>
      `/cleaning/cleaning-checklist/preview/${checklistType}/${cleaningId}`,
    inspectionChecklist: (cleaningId: number) =>
      `/cleaning/cleaning-checklist/${ChecklistSectionType.Inspection}/${cleaningId}`,
    helperChecklist: (cleaningId: number) => `/cleaning/cleaning-checklist/${ChecklistSectionType.Helper}/${cleaningId}`
  }
};
